function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
/**
 * Whitelist-based JavaScript security validator for untrusted source.
 *
 * Validates source against a restrictive policy by parsing with Acorn and
 * walking the AST. Does not execute, rewrite, or "repair" the source.
 *
 * This is one layer of a broader sandbox (Worker + capability messaging).
 * Successful validation is not a complete sandbox guarantee.
 */

var acorn = require('acorn');
var DANGEROUS_PROPERTIES = new Set(['constructor', 'prototype', '__proto__', '__defineGetter__', '__defineSetter__', '__lookupGetter__', '__lookupSetter__']);
var ALWAYS_BANNED_GLOBALS = new Set(['window', 'globalThis', 'self', 'global', 'frames', 'parent', 'top', 'document', 'process', 'require', 'module', 'exports', 'eval', 'Function', 'Reflect', 'Proxy', 'Object', 'Array', 'Promise', 'Symbol', 'Map', 'Set', 'WeakMap', 'WeakSet', 'RegExp', 'Error', 'Date', 'JSON', 'Math', 'Number', 'String', 'Boolean', 'parseInt', 'parseFloat', 'isNaN', 'isFinite', 'arguments', 'debugger', 'with', 'this', 'Worker', 'SharedWorker', 'importScripts', 'Atomics', 'WebAssembly', 'SharedArrayBuffer', 'Intl', 'Deno', 'Bun', 'console', 'alert', 'confirm', 'prompt', 'setTimeout', 'setInterval', 'clearTimeout', 'clearInterval', 'queueMicrotask', 'requestAnimationFrame', 'cancelAnimationFrame', 'structuredClone', 'navigator', 'location', 'history', 'crypto', 'performance', 'caches', 'cookieStore']);
var STORAGE_GLOBALS = new Set(['localStorage', 'sessionStorage', 'indexedDB']);
var NETWORK_GLOBALS = new Set(['fetch', 'XMLHttpRequest', 'WebSocket', 'EventSource', 'AbortController', 'Headers', 'Request', 'Response']);
var EVENT_PROPERTIES = new Set(['addEventListener', 'removeEventListener', 'dispatchEvent', 'on', 'once', 'emit', 'off', 'removeListener', 'addListener', 'prependListener', 'prependOnceListener']);

// Language-level identifier literals (not mutable globals in practical terms).
var SAFE_LANGUAGE_IDENTIFIERS = new Set(['undefined', 'NaN', 'Infinity']);
var DEFAULT_ALLOWED_SYNTAX = ['functions', 'variables', 'objects', 'arrays', 'conditionals', 'loops', 'arithmetic', 'comparisons', 'logical', 'strings', 'literals', 'returns', 'sequences', 'blocks'];
var SYNTAX_NODE_MAP = {
  functions: new Set(['FunctionDeclaration', 'FunctionExpression', 'ArrowFunctionExpression']),
  variables: new Set(['VariableDeclaration', 'VariableDeclarator', 'AssignmentExpression', 'UpdateExpression']),
  objects: new Set(['ObjectExpression', 'Property', 'ObjectPattern']),
  arrays: new Set(['ArrayExpression', 'ArrayPattern', 'SpreadElement']),
  conditionals: new Set(['IfStatement', 'ConditionalExpression', 'SwitchStatement', 'SwitchCase']),
  loops: new Set(['ForStatement', 'ForInStatement', 'ForOfStatement', 'WhileStatement', 'DoWhileStatement', 'BreakStatement', 'ContinueStatement']),
  arithmetic: new Set([]),
  // handled via operator checks on Binary/Unary/Assignment
  comparisons: new Set([]),
  logical: new Set(['LogicalExpression']),
  strings: new Set(['TemplateLiteral', 'TemplateElement', 'TaggedTemplateExpression']),
  literals: new Set(['Literal', 'Identifier']),
  returns: new Set(['ReturnStatement']),
  sequences: new Set(['SequenceExpression']),
  blocks: new Set(['BlockStatement', 'ExpressionStatement', 'EmptyStatement'])
};
var ARITHMETIC_OPS = new Set(['+', '-', '*', '/', '%', '**', '|', '&', '^', '~', '<<', '>>', '>>>']);
var COMPARISON_OPS = new Set(['==', '===', '!=', '!==', '<', '<=', '>', '>=']);
var LOGICAL_OPS = new Set(['&&', '||', '??', '!']);
var ASSIGNMENT_OPS = new Set(['=', '+=', '-=', '*=', '/=', '%=', '**=', '<<=', '>>=', '>>>=', '|=', '&=', '^=']);
function locOf(node) {
  var loc = node && node.loc && node.loc.start ? node.loc.start : null;
  return {
    line: loc ? loc.line : null,
    column: loc ? loc.column + 1 : null
  };
}
function makeError(type, message, node) {
  var _locOf = locOf(node),
    line = _locOf.line,
    column = _locOf.column;
  return {
    type: type,
    message: message,
    line: line,
    column: column
  };
}
function normalizeAllowedMethods(raw) {
  if (!raw) {
    return {};
  }
  if (Array.isArray(raw)) {
    // Flat list is ambiguous without object context; treat as empty and require map form.
    return {};
  }
  var out = {};
  for (var _i = 0, _Object$entries = Object.entries(raw); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      objectName = _Object$entries$_i[0],
      methods = _Object$entries$_i[1];
    out[objectName] = new Set(Array.isArray(methods) ? methods : []);
  }
  return out;
}
function normalizeAllowedProperties(raw) {
  if (!raw) {
    return {};
  }
  if (Array.isArray(raw)) {
    return {};
  }
  var out = {};
  for (var _i2 = 0, _Object$entries2 = Object.entries(raw); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      objectName = _Object$entries2$_i[0],
      props = _Object$entries2$_i[1];
    out[objectName] = new Set(Array.isArray(props) ? props : []);
  }
  return out;
}
function mergePolicy() {
  var policy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var allowedSyntax = Array.isArray(policy.allowedSyntax) ? policy.allowedSyntax.slice() : DEFAULT_ALLOWED_SYNTAX.slice();
  return {
    allowedGlobals: new Set(policy.allowedGlobals || []),
    allowedObjects: new Set(policy.allowedObjects || []),
    allowedMethods: normalizeAllowedMethods(policy.allowedMethods),
    allowedProperties: normalizeAllowedProperties(policy.allowedProperties),
    allowedSyntax: new Set(allowedSyntax),
    allowDynamicExecution: policy.allowDynamicExecution === true,
    allowImports: policy.allowImports === true,
    allowEvents: policy.allowEvents === true,
    allowStorage: policy.allowStorage === true,
    allowNetwork: policy.allowNetwork === true,
    allowAsync: policy.allowAsync === true,
    allowComputedProperties: policy.allowComputedProperties === true
  };
}
function isDangerousPropertyName(name) {
  return typeof name === 'string' && DANGEROUS_PROPERTIES.has(name);
}
function bindingKind(kind) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread({
    kind: kind
  }, meta);
}
var Scope = /*#__PURE__*/function () {
  function Scope() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, Scope);
    this.parent = parent;
    this.bindings = new Map();
  }
  return _createClass(Scope, [{
    key: "declare",
    value: function declare(name, info) {
      this.bindings.set(name, info);
    }
  }, {
    key: "lookup",
    value: function lookup(name) {
      if (this.bindings.has(name)) {
        return this.bindings.get(name);
      }
      if (this.parent) {
        return this.parent.lookup(name);
      }
      return null;
    }
  }]);
}();
function createSanitizeJS() {
  /**
   * @param {string} source
   * @param {object} [policy]
   * @returns {{ safe: boolean, errors: Array, warnings: Array }}
   */
  function sanitizeJS(source) {
    var policy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var warnings = [];
    var errors = [];
    var cfg = mergePolicy(policy);
    if (typeof source !== 'string') {
      return {
        safe: false,
        errors: [{
          type: 'invalid_source',
          message: 'Source must be a string',
          line: null,
          column: null
        }],
        warnings: warnings
      };
    }
    var ast;
    try {
      ast = acorn.parse(source, {
        ecmaVersion: 2020,
        sourceType: 'script',
        locations: true,
        allowAwaitOutsideFunction: false,
        allowHashBang: false,
        allowReturnOutsideFunction: false
      });
    } catch (err) {
      return {
        safe: false,
        errors: [{
          type: 'parse_error',
          message: err.message || 'Failed to parse JavaScript',
          line: err.loc ? err.loc.line : null,
          column: err.loc ? err.loc.column + 1 : null
        }],
        warnings: warnings
      };
    }
    var rootScope = new Scope(null);
    // Seed allowed objects into the root scope as authorized bindings.
    var _iterator = _createForOfIteratorHelper(cfg.allowedObjects),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var name = _step.value;
        rootScope.declare(name, bindingKind('allowed_object', {
          objectName: name
        }));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var _iterator2 = _createForOfIteratorHelper(cfg.allowedGlobals),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _name = _step2.value;
        if (!ALWAYS_BANNED_GLOBALS.has(_name) && !cfg.allowedObjects.has(_name)) {
          rootScope.declare(_name, bindingKind('allowed_global', {
            globalName: _name
          }));
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    function reject(type, message, node) {
      errors.push(makeError(type, message, node));
    }
    function syntaxAllowed(feature) {
      return cfg.allowedSyntax.has(feature);
    }
    function nodeTypeAllowed(type) {
      if (type === 'Program') {
        return true;
      }
      if (type === 'CallExpression' || type === 'MemberExpression' || type === 'ChainExpression') {
        return true; // gated by deeper checks
      }
      if (type === 'UnaryExpression' || type === 'BinaryExpression' || type === 'AssignmentExpression') {
        return true; // gated by operator checks
      }
      if (type === 'ThrowStatement' || type === 'TryStatement' || type === 'CatchClause') {
        return false;
      }
      if (type === 'ClassDeclaration' || type === 'ClassExpression' || type === 'ClassBody' || type === 'MethodDefinition') {
        return false;
      }
      if (type === 'ImportDeclaration' || type === 'ExportNamedDeclaration' || type === 'ExportDefaultDeclaration' || type === 'ExportAllDeclaration' || type === 'ImportExpression') {
        return cfg.allowImports;
      }
      if (type === 'AwaitExpression' || type === 'YieldExpression') {
        return cfg.allowAsync;
      }
      if (type === 'MetaProperty' || type === 'NewExpression' || type === 'ThisExpression' || type === 'Super' || type === 'WithStatement' || type === 'LabeledStatement') {
        return false;
      }
      for (var _i3 = 0, _Object$entries3 = Object.entries(SYNTAX_NODE_MAP); _i3 < _Object$entries3.length; _i3++) {
        var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
          feature = _Object$entries3$_i[0],
          types = _Object$entries3$_i[1];
        if (types.has(type)) {
          return syntaxAllowed(feature);
        }
      }
      // Unknown node type → reject (fail closed)
      return false;
    }
    function isBannedGlobalName(name) {
      if (ALWAYS_BANNED_GLOBALS.has(name)) {
        return true;
      }
      if (!cfg.allowStorage && STORAGE_GLOBALS.has(name)) {
        return true;
      }
      if (!cfg.allowNetwork && NETWORK_GLOBALS.has(name)) {
        return true;
      }
      if (!cfg.allowDynamicExecution && (name === 'eval' || name === 'Function')) {
        return true;
      }
      return false;
    }
    function resolveIdentifier(name, scope, node) {
      var local = scope.lookup(name);
      if (local) {
        return local;
      }
      if (SAFE_LANGUAGE_IDENTIFIERS.has(name)) {
        return bindingKind('primitive');
      }
      if (cfg.allowedObjects.has(name)) {
        return bindingKind('allowed_object', {
          objectName: name
        });
      }
      if (cfg.allowedGlobals.has(name) && !isBannedGlobalName(name)) {
        return bindingKind('allowed_global', {
          globalName: name
        });
      }
      if (isBannedGlobalName(name)) {
        reject('unauthorized_access', "Unauthorized global reference: ".concat(name), node);
        return bindingKind('forbidden');
      }
      reject('unauthorized_access', "Unauthorized global reference: ".concat(name), node);
      return bindingKind('forbidden');
    }
    function staticPropertyName(node) {
      if (!node) {
        return null;
      }
      if (node.type === 'Identifier') {
        return node.name;
      }
      if (node.type === 'Literal' && typeof node.value === 'string') {
        return node.value;
      }
      if (node.type === 'Literal' && typeof node.value === 'number') {
        return String(node.value);
      }
      return null;
    }
    function checkPropertyName(name, node, contextLabel) {
      if (name == null) {
        reject('unauthorized_access', "Unsupported or non-static property access".concat(contextLabel ? " (".concat(contextLabel, ")") : ''), node);
        return false;
      }
      if (isDangerousPropertyName(name)) {
        reject('unauthorized_access', "Unauthorized property access: ".concat(name), node);
        return false;
      }
      if (!cfg.allowEvents && EVENT_PROPERTIES.has(name)) {
        reject('unauthorized_access', "Unauthorized event API access: ".concat(name), node);
        return false;
      }
      return true;
    }

    /**
     * Classify an expression's value origin for access-control decisions.
     * Returns a binding descriptor.
     */
    function classify(node, scope) {
      if (!node) {
        return bindingKind('unknown');
      }
      switch (node.type) {
        case 'Identifier':
          return resolveIdentifier(node.name, scope, node);
        case 'Literal':
          return bindingKind('primitive');
        case 'TemplateLiteral':
          return bindingKind('primitive');
        case 'ArrayExpression':
          return bindingKind('local');
        case 'ObjectExpression':
          return bindingKind('local');
        case 'FunctionExpression':
        case 'ArrowFunctionExpression':
          return bindingKind('local_function');
        case 'UnaryExpression':
        case 'BinaryExpression':
        case 'LogicalExpression':
        case 'ConditionalExpression':
        case 'UpdateExpression':
        case 'SequenceExpression':
          return bindingKind('primitive');
        case 'MemberExpression':
        case 'ChainExpression':
          {
            var member = node.type === 'ChainExpression' ? node.expression : node;
            return classifyMember(member, scope);
          }
        case 'CallExpression':
          return classifyCall(node, scope);
        case 'AssignmentExpression':
          return classify(node.right, scope);
        default:
          return bindingKind('unknown');
      }
    }
    function classifyMember(node, scope) {
      var objectInfo = classify(node.object, scope);
      if (node.computed && !cfg.allowComputedProperties) {
        // Allow only static string/number literals that we can check.
        if (node.property.type !== 'Literal') {
          reject('unauthorized_access', 'Computed property access is not permitted', node);
          return bindingKind('forbidden');
        }
      }
      var propName = staticPropertyName(node.property);
      if (node.computed && node.property.type === 'Literal' && typeof node.property.value !== 'string' && typeof node.property.value !== 'number') {
        reject('unauthorized_access', 'Computed property access is not permitted', node);
        return bindingKind('forbidden');
      }
      if (!checkPropertyName(propName, node, 'member')) {
        return bindingKind('forbidden');
      }
      if (objectInfo.kind === 'allowed_object') {
        var objectName = objectInfo.objectName;
        var methods = cfg.allowedMethods[objectName] || new Set();
        var props = cfg.allowedProperties[objectName] || new Set();
        if (methods.has(propName)) {
          return bindingKind('allowed_method', {
            objectName: objectName,
            methodName: propName
          });
        }
        if (props.has(propName)) {
          return bindingKind('allowed_property', {
            objectName: objectName,
            propertyName: propName
          });
        }
        reject('unauthorized_access', "Unauthorized property access: ".concat(objectName, ".").concat(propName), node);
        return bindingKind('forbidden');
      }
      if (objectInfo.kind === 'allowed_method' || objectInfo.kind === 'allowed_property') {
        // No chaining through authorized method/property results (blocks .constructor etc. already,
        // and blocks game.addInfluence.something).
        reject('unauthorized_access', 'Unauthorized property access through authorized reference', node);
        return bindingKind('forbidden');
      }
      if (objectInfo.kind === 'local' || objectInfo.kind === 'local_function' || objectInfo.kind === 'primitive') {
        // Locals may read/write own static properties, but never dangerous ones (already checked).
        return bindingKind('local');
      }
      if (objectInfo.kind === 'allowed_global') {
        reject('unauthorized_access', "Unauthorized property access on global: ".concat(objectInfo.globalName), node);
        return bindingKind('forbidden');
      }
      reject('unauthorized_access', 'Unauthorized property access', node);
      return bindingKind('forbidden');
    }
    function classifyCall(node, scope) {
      if (node.callee.type === 'Identifier') {
        var name = node.callee.name;
        if (!cfg.allowDynamicExecution && (name === 'eval' || name === 'Function')) {
          reject('dynamic_execution', "Dynamic code execution is not permitted: ".concat(name), node);
          return bindingKind('forbidden');
        }
      }
      var calleeInfo = classify(node.callee, scope);
      if (calleeInfo.kind === 'forbidden') {
        return bindingKind('forbidden');
      }
      if (calleeInfo.kind === 'allowed_method') {
        return bindingKind('local'); // return value treated as opaque local data
      }
      if (calleeInfo.kind === 'local_function') {
        return bindingKind('local');
      }

      // Local object/array member calls are allowed only when the property name has
      // already passed dangerous-property checks inside classifyMember.
      if (calleeInfo.kind === 'local' && (node.callee.type === 'MemberExpression' || node.callee.type === 'ChainExpression')) {
        return bindingKind('local');
      }
      reject('unauthorized_call', 'Unauthorized function call', node);
      return bindingKind('forbidden');
    }
    function declarePattern(pattern, scope, info, nodeForError) {
      if (!pattern) {
        return;
      }
      switch (pattern.type) {
        case 'Identifier':
          scope.declare(pattern.name, info);
          break;
        case 'ObjectPattern':
          var _iterator3 = _createForOfIteratorHelper(pattern.properties),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var prop = _step3.value;
              if (prop.type === 'RestElement') {
                declarePattern(prop.argument, scope, bindingKind('local'), prop);
                continue;
              }
              var keyName = staticPropertyName(prop.key);
              if (prop.computed || keyName == null) {
                reject('unauthorized_access', 'Computed or unsupported destructuring key', prop);
                continue;
              }
              if (!checkPropertyName(keyName, prop, 'destructure')) {
                continue;
              }
              // Destructuring from an allowed object must only pull allowed methods/properties.
              if (info.kind === 'allowed_object') {
                var objectName = info.objectName;
                var methods = cfg.allowedMethods[objectName] || new Set();
                var props = cfg.allowedProperties[objectName] || new Set();
                if (methods.has(keyName)) {
                  // Extracted methods become unbound — reject to avoid losing call-site checks.
                  reject('unauthorized_access', "Destructuring authorized method is not permitted: ".concat(objectName, ".").concat(keyName), prop);
                  continue;
                }
                if (!props.has(keyName)) {
                  reject('unauthorized_access', "Unauthorized destructuring: ".concat(objectName, ".").concat(keyName), prop);
                  continue;
                }
                declarePattern(prop.value, scope, bindingKind('local'), prop);
              } else if (info.kind === 'local' || info.kind === 'primitive') {
                declarePattern(prop.value, scope, bindingKind('local'), prop);
              } else {
                reject('unauthorized_access', 'Unauthorized destructuring source', nodeForError || pattern);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          break;
        case 'ArrayPattern':
          var _iterator4 = _createForOfIteratorHelper(pattern.elements),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var el = _step4.value;
              if (!el) {
                continue;
              }
              if (el.type === 'RestElement') {
                declarePattern(el.argument, scope, bindingKind('local'), el);
              } else {
                declarePattern(el, scope, bindingKind('local'), el);
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          break;
        case 'AssignmentPattern':
          declarePattern(pattern.left, scope, info, nodeForError);
          walk(pattern.right, scope);
          break;
        case 'RestElement':
          declarePattern(pattern.argument, scope, bindingKind('local'), pattern);
          break;
        default:
          reject('unsupported_syntax', "Unsupported binding pattern: ".concat(pattern.type), pattern);
      }
    }
    function walkFunction(node, parentScope) {
      if (!syntaxAllowed('functions')) {
        reject('unsupported_syntax', 'Function syntax is not permitted', node);
        return;
      }
      if ((node.async || node.generator) && !cfg.allowAsync) {
        reject('unsupported_syntax', 'Async or generator functions are not permitted', node);
        return;
      }
      var scope = new Scope(parentScope);
      var _iterator5 = _createForOfIteratorHelper(node.params),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var param = _step5.value;
          declarePattern(param, scope, bindingKind('local'), param);
          // Default values / nested patterns may contain expressions.
          if (param.type === 'AssignmentPattern') {
            // declarePattern already walks right
          } else {
            walkPatternExpressions(param, parentScope);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      if (node.id && node.id.type === 'Identifier') {
        // Function declarations bind in the parent scope; expressions may self-ref.
        if (node.type === 'FunctionDeclaration') {
          parentScope.declare(node.id.name, bindingKind('local_function'));
        } else {
          scope.declare(node.id.name, bindingKind('local_function'));
        }
      }
      if (node.body.type === 'BlockStatement') {
        walk(node.body, scope);
      } else {
        // Arrow concise body
        walk(node.body, scope);
      }
    }
    function walkPatternExpressions(pattern, scope) {
      if (!pattern) {
        return;
      }
      if (pattern.type === 'AssignmentPattern') {
        walk(pattern.right, scope);
        walkPatternExpressions(pattern.left, scope);
      } else if (pattern.type === 'ObjectPattern') {
        var _iterator6 = _createForOfIteratorHelper(pattern.properties),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var prop = _step6.value;
            if (prop.type === 'Property') {
              if (prop.computed) {
                walk(prop.key, scope);
              }
              walkPatternExpressions(prop.value, scope);
            } else if (prop.type === 'RestElement') {
              walkPatternExpressions(prop.argument, scope);
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      } else if (pattern.type === 'ArrayPattern') {
        var _iterator7 = _createForOfIteratorHelper(pattern.elements),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var el = _step7.value;
            walkPatternExpressions(el, scope);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      } else if (pattern.type === 'RestElement') {
        walkPatternExpressions(pattern.argument, scope);
      }
    }
    function checkOperator(node) {
      var op = node.operator;
      if (node.type === 'BinaryExpression') {
        if (ARITHMETIC_OPS.has(op) && !syntaxAllowed('arithmetic')) {
          reject('unsupported_syntax', "Arithmetic operator not permitted: ".concat(op), node);
        }
        if (COMPARISON_OPS.has(op) && !syntaxAllowed('comparisons') && !syntaxAllowed('conditionals')) {
          reject('unsupported_syntax', "Comparison operator not permitted: ".concat(op), node);
        }
        if (op === 'in' || op === 'instanceof') {
          reject('unsupported_syntax', "Operator not permitted: ".concat(op), node);
        }
      }
      if (node.type === 'UnaryExpression') {
        if ((op === '+' || op === '-' || op === '~') && !syntaxAllowed('arithmetic')) {
          reject('unsupported_syntax', "Arithmetic operator not permitted: ".concat(op), node);
        }
        if (op === '!' && !syntaxAllowed('logical') && !syntaxAllowed('conditionals')) {
          reject('unsupported_syntax', 'Logical operator not permitted: !', node);
        }
        if (op === 'typeof' || op === 'delete' || op === 'void') {
          reject('unsupported_syntax', "Operator not permitted: ".concat(op), node);
        }
      }
      if (node.type === 'LogicalExpression') {
        if (!syntaxAllowed('logical') && !syntaxAllowed('conditionals')) {
          reject('unsupported_syntax', "Logical operator not permitted: ".concat(op), node);
        }
      }
      if (node.type === 'AssignmentExpression') {
        if (!syntaxAllowed('variables')) {
          reject('unsupported_syntax', 'Assignment is not permitted', node);
        }
        if (!ASSIGNMENT_OPS.has(op)) {
          reject('unsupported_syntax', "Assignment operator not permitted: ".concat(op), node);
        }
        if (op !== '=' && ARITHMETIC_OPS.has(op.replace('=', '')) && !syntaxAllowed('arithmetic')) {
          reject('unsupported_syntax', "Arithmetic assignment not permitted: ".concat(op), node);
        }
      }
    }
    function walk(node, scope) {
      if (!node || errors.length > 50) {
        return;
      }
      if (!nodeTypeAllowed(node.type)) {
        if ((node.type === 'ImportExpression' || node.type.startsWith('Import') || node.type.startsWith('Export')) && !cfg.allowImports) {
          reject('unauthorized_import', 'Import/export syntax is not permitted', node);
        } else if ((node.type === 'AwaitExpression' || node.type === 'YieldExpression') && !cfg.allowAsync) {
          reject('unsupported_syntax', "".concat(node.type, " is not permitted"), node);
        } else {
          reject('unsupported_syntax', "Unsupported syntax: ".concat(node.type), node);
        }
        return;
      }
      switch (node.type) {
        case 'Program':
          var _iterator8 = _createForOfIteratorHelper(node.body),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var stmt = _step8.value;
              if (stmt.type === 'FunctionDeclaration' && stmt.id && stmt.id.type === 'Identifier') {
                scope.declare(stmt.id.name, bindingKind('local_function'));
              }
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          var _iterator9 = _createForOfIteratorHelper(node.body),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var _stmt = _step9.value;
              walk(_stmt, scope);
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
          break;
        case 'BlockStatement':
          {
            var blockScope = new Scope(scope);
            var _iterator0 = _createForOfIteratorHelper(node.body),
              _step0;
            try {
              for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                var _stmt2 = _step0.value;
                if (_stmt2.type === 'FunctionDeclaration' && _stmt2.id && _stmt2.id.type === 'Identifier') {
                  blockScope.declare(_stmt2.id.name, bindingKind('local_function'));
                }
              }
            } catch (err) {
              _iterator0.e(err);
            } finally {
              _iterator0.f();
            }
            var _iterator1 = _createForOfIteratorHelper(node.body),
              _step1;
            try {
              for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
                var _stmt3 = _step1.value;
                walk(_stmt3, blockScope);
              }
            } catch (err) {
              _iterator1.e(err);
            } finally {
              _iterator1.f();
            }
          }
          break;
        case 'ExpressionStatement':
          walk(node.expression, scope);
          break;
        case 'EmptyStatement':
          break;
        case 'VariableDeclaration':
          if (!syntaxAllowed('variables')) {
            reject('unsupported_syntax', 'Variable declarations are not permitted', node);
            break;
          }
          var _iterator10 = _createForOfIteratorHelper(node.declarations),
            _step10;
          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var decl = _step10.value;
              walk(decl, scope);
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
          break;
        case 'VariableDeclarator':
          {
            var info = bindingKind('local');
            if (node.init) {
              walk(node.init, scope);
              info = classify(node.init, scope);
              // Aliasing an allowed object preserves the binding kind.
              if (info.kind === 'allowed_method') {
                // Do not allow storing method references for later unbound calls.
                reject('unauthorized_access', 'Storing authorized method references is not permitted', node);
                info = bindingKind('forbidden');
              } else if (info.kind === 'forbidden' || info.kind === 'unknown') {
                info = bindingKind('forbidden');
              }
            }
            declarePattern(node.id, scope, info, node);
            break;
          }
        case 'FunctionDeclaration':
          walkFunction(node, scope);
          break;
        case 'FunctionExpression':
        case 'ArrowFunctionExpression':
          walkFunction(node, scope);
          break;
        case 'ReturnStatement':
          if (!syntaxAllowed('returns')) {
            reject('unsupported_syntax', 'Return statements are not permitted', node);
            break;
          }
          if (node.argument) {
            walk(node.argument, scope);
          }
          break;
        case 'IfStatement':
          if (!syntaxAllowed('conditionals')) {
            reject('unsupported_syntax', 'Conditionals are not permitted', node);
            break;
          }
          walk(node.test, scope);
          walk(node.consequent, scope);
          if (node.alternate) {
            walk(node.alternate, scope);
          }
          break;
        case 'ConditionalExpression':
          if (!syntaxAllowed('conditionals')) {
            reject('unsupported_syntax', 'Conditionals are not permitted', node);
            break;
          }
          walk(node.test, scope);
          walk(node.consequent, scope);
          walk(node.alternate, scope);
          break;
        case 'SwitchStatement':
          if (!syntaxAllowed('conditionals')) {
            reject('unsupported_syntax', 'Switch statements are not permitted', node);
            break;
          }
          walk(node.discriminant, scope);
          var _iterator11 = _createForOfIteratorHelper(node.cases),
            _step11;
          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var c = _step11.value;
              walk(c, scope);
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
          break;
        case 'SwitchCase':
          if (node.test) {
            walk(node.test, scope);
          }
          var _iterator12 = _createForOfIteratorHelper(node.consequent),
            _step12;
          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var cons = _step12.value;
              walk(cons, scope);
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }
          break;
        case 'WhileStatement':
        case 'DoWhileStatement':
          if (!syntaxAllowed('loops')) {
            reject('unsupported_syntax', 'Loops are not permitted', node);
            break;
          }
          walk(node.test, scope);
          walk(node.body, scope);
          break;
        case 'ForStatement':
          if (!syntaxAllowed('loops')) {
            reject('unsupported_syntax', 'Loops are not permitted', node);
            break;
          }
          {
            var forScope = new Scope(scope);
            if (node.init) {
              walk(node.init, forScope);
            }
            if (node.test) {
              walk(node.test, forScope);
            }
            if (node.update) {
              walk(node.update, forScope);
            }
            walk(node.body, forScope);
          }
          break;
        case 'ForInStatement':
        case 'ForOfStatement':
          if (!syntaxAllowed('loops')) {
            reject('unsupported_syntax', 'Loops are not permitted', node);
            break;
          }
          {
            var _forScope = new Scope(scope);
            walk(node.right, scope);
            if (node.left.type === 'VariableDeclaration') {
              walk(node.left, _forScope);
            } else {
              // for (x of y) — x must already be a local binding target
              declarePattern(node.left, _forScope, bindingKind('local'), node.left);
            }
            walk(node.body, _forScope);
          }
          break;
        case 'BreakStatement':
        case 'ContinueStatement':
          if (!syntaxAllowed('loops') && !syntaxAllowed('conditionals')) {
            reject('unsupported_syntax', "".concat(node.type, " is not permitted"), node);
          }
          if (node.label) {
            reject('unsupported_syntax', 'Labeled break/continue is not permitted', node);
          }
          break;
        case 'Identifier':
          // Presence is validated when used as a value expression by classify/resolve.
          // Standalone Identifier nodes appear under expressions we already classify.
          resolveIdentifier(node.name, scope, node);
          break;
        case 'Literal':
          if (node.regex) {
            reject('unsupported_syntax', 'Regular expression literals are not permitted', node);
          }
          break;
        case 'TemplateLiteral':
          if (!syntaxAllowed('strings') && !syntaxAllowed('literals')) {
            reject('unsupported_syntax', 'Template literals are not permitted', node);
            break;
          }
          var _iterator13 = _createForOfIteratorHelper(node.expressions),
            _step13;
          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var expr = _step13.value;
              walk(expr, scope);
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
          break;
        case 'TaggedTemplateExpression':
          reject('unsupported_syntax', 'Tagged templates are not permitted', node);
          break;
        case 'ArrayExpression':
          if (!syntaxAllowed('arrays')) {
            reject('unsupported_syntax', 'Array literals are not permitted', node);
            break;
          }
          var _iterator14 = _createForOfIteratorHelper(node.elements),
            _step14;
          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var el = _step14.value;
              if (el) {
                walk(el, scope);
              }
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }
          break;
        case 'ObjectExpression':
          if (!syntaxAllowed('objects')) {
            reject('unsupported_syntax', 'Object literals are not permitted', node);
            break;
          }
          var _iterator15 = _createForOfIteratorHelper(node.properties),
            _step15;
          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var prop = _step15.value;
              walk(prop, scope);
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
          break;
        case 'Property':
          {
            if (node.kind === 'get' || node.kind === 'set') {
              reject('unsupported_syntax', 'Getters and setters are not permitted', node);
              break;
            }
            if (node.computed) {
              if (!cfg.allowComputedProperties) {
                // Allow only static literal keys.
                if (node.key.type !== 'Literal' || typeof node.key.value !== 'string' && typeof node.key.value !== 'number') {
                  reject('unauthorized_access', 'Computed property keys are not permitted', node);
                  break;
                }
              } else {
                walk(node.key, scope);
              }
            }
            var keyName = staticPropertyName(node.key);
            if (!checkPropertyName(keyName, node, 'object key')) {
              break;
            }
            walk(node.value, scope);
            break;
          }
        case 'SpreadElement':
          if (!syntaxAllowed('arrays') && !syntaxAllowed('objects')) {
            reject('unsupported_syntax', 'Spread syntax is not permitted', node);
            break;
          }
          // Spreading may copy dangerous properties from objects; reject spreads of non-literals.
          if (node.argument.type !== 'ArrayExpression' && node.argument.type !== 'ObjectExpression') {
            reject('unauthorized_access', 'Spreading non-literal values is not permitted', node);
            break;
          }
          walk(node.argument, scope);
          break;
        case 'MemberExpression':
          classifyMember(node, scope);
          // Walk children for nested unauthorized refs.
          walk(node.object, scope);
          if (node.computed) {
            walk(node.property, scope);
          }
          break;
        case 'ChainExpression':
          reject('unsupported_syntax', 'Optional chaining is not permitted', node);
          break;
        case 'CallExpression':
          if (node.callee.type === 'ImportExpression' || node.callee.type === 'Identifier' && node.callee.name === 'import') {
            reject('unauthorized_import', 'Dynamic import is not permitted', node);
            break;
          }
          classifyCall(node, scope);
          // Avoid double-reporting identifier globals inside authorized callees:
          // walk arguments always; walk callee carefully.
          if (node.callee.type === 'MemberExpression') {
            walk(node.callee.object, scope);
            if (node.callee.computed) {
              walk(node.callee.property, scope);
            }
          } else if (node.callee.type === 'Identifier') {
            // classifyCall/resolve already handled unauthorized globals
          } else {
            walk(node.callee, scope);
          }
          var _iterator16 = _createForOfIteratorHelper(node.arguments),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var arg = _step16.value;
              walk(arg, scope);
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
          break;
        case 'NewExpression':
          reject('unsupported_syntax', 'new expressions are not permitted', node);
          break;
        case 'UnaryExpression':
          checkOperator(node);
          walk(node.argument, scope);
          break;
        case 'BinaryExpression':
        case 'LogicalExpression':
          checkOperator(node);
          walk(node.left, scope);
          walk(node.right, scope);
          break;
        case 'AssignmentExpression':
          {
            checkOperator(node);
            walk(node.right, scope);
            var rightInfo = classify(node.right, scope);
            if (node.left.type === 'Identifier') {
              var existing = scope.lookup(node.left.name);
              if (!existing) {
                reject('unauthorized_access', "Assignment to undeclared identifier: ".concat(node.left.name), node.left);
              } else if (rightInfo.kind === 'allowed_method') {
                reject('unauthorized_access', 'Storing authorized method references is not permitted', node);
              } else if (rightInfo.kind === 'allowed_object' || rightInfo.kind === 'allowed_property' || rightInfo.kind === 'local' || rightInfo.kind === 'primitive' || rightInfo.kind === 'local_function' || rightInfo.kind === 'allowed_global') {
                scope.declare(node.left.name, rightInfo.kind === 'forbidden' ? bindingKind('forbidden') : rightInfo);
              } else {
                scope.declare(node.left.name, bindingKind('forbidden'));
              }
            } else if (node.left.type === 'MemberExpression') {
              classifyMember(node.left, scope);
              walk(node.left.object, scope);
              if (node.left.computed) {
                walk(node.left.property, scope);
              }
            } else {
              reject('unsupported_syntax', 'Unsupported assignment target', node.left);
            }
            break;
          }
        case 'UpdateExpression':
          if (!syntaxAllowed('arithmetic') && !syntaxAllowed('variables')) {
            reject('unsupported_syntax', 'Update expressions are not permitted', node);
            break;
          }
          walk(node.argument, scope);
          break;
        case 'SequenceExpression':
          if (!syntaxAllowed('sequences')) {
            reject('unsupported_syntax', 'Sequence expressions are not permitted', node);
            break;
          }
          var _iterator17 = _createForOfIteratorHelper(node.expressions),
            _step17;
          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _expr = _step17.value;
              walk(_expr, scope);
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
          break;
        case 'ThisExpression':
          reject('unauthorized_access', 'Unauthorized this reference', node);
          break;
        case 'AwaitExpression':
          if (!cfg.allowAsync) {
            reject('unsupported_syntax', 'AwaitExpression is not permitted', node);
            break;
          }
          walk(node.argument, scope);
          break;
        case 'YieldExpression':
          if (!cfg.allowAsync) {
            reject('unsupported_syntax', 'YieldExpression is not permitted', node);
            break;
          }
          if (node.argument) {
            walk(node.argument, scope);
          }
          break;
        case 'ImportExpression':
          reject('unauthorized_import', 'Dynamic import is not permitted', node);
          break;
        default:
          reject('unsupported_syntax', "Unsupported syntax: ".concat(node.type), node);
          break;
      }
    }
    walk(ast, rootScope);

    // Deduplicate nearly-identical errors (same type/message/line/column)
    var seen = new Set();
    var uniqueErrors = [];
    for (var _i4 = 0, _errors = errors; _i4 < _errors.length; _i4++) {
      var err = _errors[_i4];
      var key = "".concat(err.type, "|").concat(err.message, "|").concat(err.line, "|").concat(err.column);
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      uniqueErrors.push(err);
    }
    return {
      safe: uniqueErrors.length === 0,
      errors: uniqueErrors,
      warnings: warnings
    };
  }
  return sanitizeJS;
}
var sanitizeJSImpl = createSanitizeJS();
var _require = require('./sandbox'),
  createSandbox = _require.createSandbox;

// ---------------------------------------------------------------------------
// Isolated execution (persistent sandbox + capability messaging)
// ---------------------------------------------------------------------------

var DEFAULT_EXECUTION_POLICY = {
  allowNetwork: false,
  allowStorage: false,
  allowEvents: false,
  allowImports: false,
  allowDynamicExecution: false,
  allowAsync: true,
  maxExecutionTime: 5000,
  maxMessages: 1000,
  maxMessageSize: 65536
};
function isPlainObject(value) {
  if (value === null || _typeof(value) !== 'object') {
    return false;
  }
  var proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

/**
 * Deep-clone values that are safe to transfer to/from a Worker.
 * Rejects functions, class instances, DOM nodes, symbols, bigint, and cycles.
 */
function serializeTransferable(value) {
  var _ArrayBuffer$isView;
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  var seen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new WeakSet();
  var t = _typeof(value);
  if (value === null || t === 'string' || t === 'boolean') {
    return value;
  }
  if (t === 'number') {
    if (!Number.isFinite(value)) {
      throw new Error("Unsupported non-finite number in ".concat(label));
    }
    return value;
  }
  if (t === 'undefined') {
    throw new Error("Unsupported undefined in ".concat(label));
  }
  if (t === 'bigint' || t === 'symbol' || t === 'function') {
    throw new Error("Unsupported type '".concat(t, "' in ").concat(label));
  }
  if (t !== 'object') {
    throw new Error("Unsupported type '".concat(t, "' in ").concat(label));
  }
  if (seen.has(value)) {
    throw new Error("Circular reference in ".concat(label));
  }
  if (Array.isArray(value)) {
    seen.add(value);
    return value.map(function (item, i) {
      return serializeTransferable(item, "".concat(label, "[").concat(i, "]"), seen);
    });
  }
  if (value instanceof Date || value instanceof RegExp || value instanceof Map || value instanceof Set || value instanceof Error) {
    throw new Error("Unsupported object type in ".concat(label));
  }
  if (typeof ArrayBuffer !== 'undefined' && (value instanceof ArrayBuffer || (_ArrayBuffer$isView = ArrayBuffer.isView) !== null && _ArrayBuffer$isView !== void 0 && _ArrayBuffer$isView.call(ArrayBuffer, value))) {
    throw new Error("Unsupported binary data in ".concat(label));
  }
  if (!isPlainObject(value)) {
    throw new Error("Unsupported object (non-plain) in ".concat(label));
  }
  seen.add(value);
  var out = {};
  for (var _i5 = 0, _Object$keys = Object.keys(value); _i5 < _Object$keys.length; _i5++) {
    var key = _Object$keys[_i5];
    if (isDangerousPropertyName(key)) {
      throw new Error("Unsupported property name '".concat(key, "' in ").concat(label));
    }
    out[key] = serializeTransferable(value[key], "".concat(label, ".").concat(key), seen);
  }
  return out;
}
function normalizeCapabilities() {
  var capabilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!capabilities || _typeof(capabilities) !== 'object' || Array.isArray(capabilities)) {
    throw new Error('context.capabilities must be a plain object');
  }
  var handlers = {};
  var descriptors = {};
  for (var _i6 = 0, _Object$entries4 = Object.entries(capabilities); _i6 < _Object$entries4.length; _i6++) {
    var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i6], 2),
      namespace = _Object$entries4$_i[0],
      methods = _Object$entries4$_i[1];
    if (!namespace || typeof namespace !== 'string') {
      throw new Error('Invalid capability namespace');
    }
    if (isDangerousPropertyName(namespace)) {
      throw new Error("Unauthorized capability namespace: ".concat(namespace));
    }
    if (!methods || _typeof(methods) !== 'object' || Array.isArray(methods)) {
      throw new Error("Capability namespace '".concat(namespace, "' must map to an object of methods"));
    }
    handlers[namespace] = {};
    descriptors[namespace] = [];
    for (var _i7 = 0, _Object$entries5 = Object.entries(methods); _i7 < _Object$entries5.length; _i7++) {
      var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i7], 2),
        method = _Object$entries5$_i[0],
        impl = _Object$entries5$_i[1];
      if (!method || typeof method !== 'string' || isDangerousPropertyName(method)) {
        throw new Error("Invalid capability method: ".concat(namespace, ".").concat(method));
      }
      var fn = typeof impl === 'function' ? impl : impl && typeof impl.handler === 'function' ? impl.handler : null;
      if (!fn) {
        throw new Error("Capability ".concat(namespace, ".").concat(method, " must be a function"));
      }
      handlers[namespace][method] = {
        fn: fn,
        validateArgs: _typeof(impl) === 'object' && typeof impl.validateArgs === 'function' ? impl.validateArgs : null
      };
      descriptors[namespace].push(method);
    }
  }
  return {
    handlers: handlers,
    descriptors: descriptors
  };
}
function buildValidationPolicy(policy, capabilityDescriptors) {
  var dataKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var merged = _objectSpread(_objectSpread({}, DEFAULT_EXECUTION_POLICY), policy || {});
  var allowedObjects = new Set(merged.allowedObjects || []);
  var allowedMethods = _objectSpread({}, merged.allowedMethods || {});
  var allowedGlobals = new Set(merged.allowedGlobals || []);
  for (var _i8 = 0, _Object$entries6 = Object.entries(capabilityDescriptors); _i8 < _Object$entries6.length; _i8++) {
    var _Object$entries6$_i = _slicedToArray(_Object$entries6[_i8], 2),
      namespace = _Object$entries6$_i[0],
      methods = _Object$entries6$_i[1];
    allowedObjects.add(namespace);
    var existing = new Set(allowedMethods[namespace] || []);
    var _iterator18 = _createForOfIteratorHelper(methods),
      _step18;
    try {
      for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
        var method = _step18.value;
        existing.add(method);
      }
    } catch (err) {
      _iterator18.e(err);
    } finally {
      _iterator18.f();
    }
    allowedMethods[namespace] = Array.from(existing);
  }

  // Data bindings are injected as function parameters in the Worker, so treat
  // their names as authorized identifiers during validation of the wrapped body.
  var _iterator19 = _createForOfIteratorHelper(dataKeys),
    _step19;
  try {
    for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
      var key = _step19.value;
      if (typeof key === 'string' && key && !isDangerousPropertyName(key)) {
        allowedGlobals.add(key);
      }
    }
  } catch (err) {
    _iterator19.e(err);
  } finally {
    _iterator19.f();
  }
  return _objectSpread(_objectSpread({}, merged), {}, {
    allowedObjects: Array.from(allowedObjects),
    allowedMethods: allowedMethods,
    allowedGlobals: Array.from(allowedGlobals),
    // Capability stubs are async; awaiting them is the supported call style.
    allowAsync: true,
    allowNetwork: merged.allowNetwork === true,
    allowStorage: merged.allowStorage === true,
    allowEvents: merged.allowEvents === true,
    allowImports: merged.allowImports === true,
    allowDynamicExecution: merged.allowDynamicExecution === true
  });
}

/**
 * Validate the same shape the Worker executes: an async function body.
 * This permits top-level return/await inside the script without relaxing
 * script-mode sanitizeJS() for unrelated callers.
 */
function wrapSourceForExecutionValidation(source) {
  return "async function __saito_exec__() {\n".concat(source, "\n}");
}

/**
 * Helper object owning the persistent sandbox. Browser must call methods on
 * this object (do not destructure executeJS unbound).
 */
var sanitizeHelper = {
  sandbox: null,
  sanitizeJS: function sanitizeJS(source) {
    var policy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return sanitizeJSImpl(source, policy);
  },
  /**
   * Validate and execute untrusted JavaScript in the persistent sandbox.
   * Creates and initializes the sandbox on first use; reuses it afterward.
   */
  executeJS: function executeJS(source) {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var context, policy, execPolicy, capabilities, rawData, _normalizeCapabilitie, handlers, descriptors, data, validationPolicy, validation, detail, err, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            context = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
            policy = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
            if (!(typeof source !== 'string')) {
              _context.n = 1;
              break;
            }
            throw new Error('JavaScript source must be a string');
          case 1:
            execPolicy = _objectSpread(_objectSpread({}, DEFAULT_EXECUTION_POLICY), policy || {});
            capabilities = context && context.capabilities ? context.capabilities : {};
            rawData = context && context.data ? context.data : {};
            _normalizeCapabilitie = normalizeCapabilities(capabilities), handlers = _normalizeCapabilitie.handlers, descriptors = _normalizeCapabilitie.descriptors;
            _context.p = 2;
            data = serializeTransferable(rawData, 'context.data');
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            throw new Error("Invalid execution data: ".concat(_t.message));
          case 4:
            validationPolicy = buildValidationPolicy(execPolicy, descriptors, Object.keys(data));
            validation = _this.sanitizeJS(wrapSourceForExecutionValidation(source), validationPolicy);
            if (validation.safe) {
              _context.n = 5;
              break;
            }
            detail = validation.errors.map(function (e) {
              return e.message;
            }).join('; ');
            err = new Error(detail ? "JavaScript validation failed: ".concat(detail) : 'JavaScript validation failed');
            err.validation = validation;
            throw err;
          case 5:
            if (!(!_this.sandbox || _this.sandbox.isTerminated())) {
              _context.n = 9;
              break;
            }
            _this.sandbox = createSandbox();
            _context.p = 6;
            _context.n = 7;
            return _this.sandbox.initialize();
          case 7:
            _context.n = 9;
            break;
          case 8:
            _context.p = 8;
            _t2 = _context.v;
            _this.sandbox = null;
            throw _t2;
          case 9:
            return _context.a(2, _this.sandbox.execute({
              source: source,
              data: data,
              capabilities: descriptors,
              handlers: handlers,
              limits: {
                maxExecutionTime: execPolicy.maxExecutionTime,
                maxMessages: execPolicy.maxMessages,
                maxMessageSize: execPolicy.maxMessageSize
              }
            }));
        }
      }, _callee, null, [[6, 8], [2, 3]]);
    }))();
  }
};
module.exports = sanitizeHelper;
module.exports.sanitizeJS = sanitizeHelper.sanitizeJS.bind(sanitizeHelper);
module.exports.executeJS = sanitizeHelper.executeJS.bind(sanitizeHelper);
module.exports.serializeTransferable = serializeTransferable;
module.exports.DEFAULT_ALLOWED_SYNTAX = DEFAULT_ALLOWED_SYNTAX;
module.exports.DEFAULT_EXECUTION_POLICY = DEFAULT_EXECUTION_POLICY;
module.exports.DANGEROUS_PROPERTIES = DANGEROUS_PROPERTIES;